<template>
    <div class='card' v-loading="loading">
        <div class='card-header'>
            <el-row type="flex" justify="center">
            <el-col :span="12">
                <label class='az-content-label' style='text-transform: none'>Members with no insurance cover
                  <span style="font-size:12px;font-weight:400">{{dateformats.getFinancialYear()}}</span>
                </label>
            </el-col>
            <el-col :span="8">
                <el-input 
                    style="fload:right"
                    size='mini'
                    v-model="message" 
                    prefix-icon="el-icon-search"
                    placeholder="Search">
                </el-input>
            </el-col>
            <el-col :span="4" >
                <span style="float:right">
                  <el-button size="mini" v-on:click="other.exportExcel('Members with no insurance cover.xlsx')">Excel</el-button>
                  <el-button size="mini" v-on:click="generateReport">PDF</el-button>
                </span>
            </el-col>
        </el-row>
        </div>
        <div class='card-body tx-13' >
          <el-table
                :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                stripe
                size="small"
                style="width: 100%;font-size:13px"
                :default-sort = "{prop: 'fund_name', order: 'ascending'}"
                >
                <el-table-column
                prop="fund_name,fund_code"
                label="Fund Name"
                sortable
                style='font-weight:500'
                >
                <template slot-scope="scope" >
                    <div style='font-weight:500'>
                    <router-link :to="{path:'/funddashboard/'+scope.row['fund_code'],query:{name:scope.row['fund_name']}}">{{isSample?'Sample Family Super Fund ':scope.row['fund_name']}} </router-link>
                    </div>
                </template>
                </el-table-column>
                <el-table-column
                prop="trustee_name"
                label="Member"
                sortable
                >
                </el-table-column>
                <el-table-column
                prop="age"
                label="Age"
                sortable
                >
                </el-table-column>
            </el-table>
            <div style="text-align: center;margin-top: 60px;">
            <el-pagination
                :current-page="currentPage"
                :page-size="pagesize"
                layout="total, prev, pager, next, jumper"
                :total="total"
                @current-change="current_change">
            </el-pagination>
            </div>
            <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="1400"
            filename="Cash at Bank"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="90%"
    
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            ref="html2Pdf"
        >
        <section slot="pdf-content">
            <table id="table" class="table">
              <thead>
                <tr>
                  <th>Fund Name</th>
                  <th>Member</th>
                  <th>Age</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(insur,index) in insurance" :key="index" v-show="insur.fund_name.toLowerCase().match(message.toLowerCase())">
                  <td style='font-weight:500'><router-link :to="{path:'/funddashboard/'+insur.fund_code,query:{name:insur.fund_name}}">{{isSample?'Sample Family Super Fund '+(index+1):insur.fund_name}} </router-link></td>
                  <td>{{isSample?'Mr Mike Sample '+(index+1):insur.trustee_name}}</td>
                  <td>{{insur.age}}</td>
                </tr>
              </tbody>
            </table>
          </section>
        </vue-html2pdf>
        </div>
    </div>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
import other from '../../../utils/other'
import dateformats from '../../../utils/dateformats'
export default {
    name:'insurance',
    components: { 
      VueHtml2pdf,
    },
    data(){
        return{
            isSample:false,
            dateformats:dateformats,
            other:other,
            message:'',
            insurance:[],
            loading:true,
            total: 0,
            pagesize:15,
            currentPage:1,
        }
    },
    computed:{
      tableData:function(){
        var message=this.message;
        if(message){
          return  this.insurance.filter(function(dataNews){
            return Object.keys(dataNews).some(function(key){
              return String(dataNews[key]).toLowerCase().indexOf(message) > -1
            })
          })
        }
        return this.insurance
      }
    },
    created(){
        this.getInsuranceData();
    },
    methods:{
        getInsuranceData: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.isSample=userdetail['sample'];
            let brand = localStorage.getItem('brand_code')
            this.$api.adviserdashboard_api.insurance(brand).then(response =>{
                this.insurance = response.data['insurance']
                this.total = this.insurance.length
                this.loading=false;
            });
        
        },
         current_change:function(currentPage){
            this.currentPage = currentPage;
        },
        generateReport () {
            this.$refs.html2Pdf.generatePdf()
        },
    }
}
</script>
<style>
.tableFixHead          { overflow: auto; height: 500px; }
.tableFixHead thead th { position: sticky; top: 0; z-index: 1; background-color: white;}

</style>